import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
const steps = [{
  num: '01',
  title: 'Elige 1 Comida Base',
  desc: 'De las 10 plantillas incluidas'
}, {
  num: '02',
  title: 'Elige 1 Micro-Ajuste',
  desc: '2 de 3: proteína/fibra/grasa buena'
}, {
  num: '03',
  title: 'Elige 1 Cena Inteligente',
  desc: 'Simple y ligera'
}, {
  num: '04',
  title: 'Puntúa tu energía',
  desc: 'A las 16:30 (0–10)'
}, {
  num: '05',
  title: 'Ajusta si es necesario',
  desc: 'Con el sistema de corrección en 48h'
}];
export function HowItWorks() {
  return <Section className="bg-[#faf8f5]" data-id="element-260">
      <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-261">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-3" data-id="element-262">
          Cómo se usa (sin complicarte)
        </h2>
        <p className="text-lg text-[#5a5a5a]" data-id="element-263">
          Cada día tomas 3 decisiones guiadas. Eso es todo.
        </p>
      </div>

      <div className="relative max-w-5xl mx-auto" data-id="element-264">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-8 left-0 w-full h-0.5 bg-[#2c4a2c]/10 -z-10" data-id="element-265" />

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6" data-id="element-266">
          {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-267">
              <div className="w-14 h-14 rounded-full bg-white border-2 border-[#2c4a2c] text-[#2c4a2c] font-bold text-lg flex items-center justify-center mb-3 group-hover:bg-[#2c4a2c] group-hover:text-white transition-colors shadow-lg" data-id="element-268">
                {step.num}
              </div>
              <h3 className="font-bold text-[#2c4a2c] mb-1 text-sm" data-id="element-269">
                {step.title}
              </h3>
              <p className="text-xs text-[#5a5a5a]" data-id="element-270">{step.desc}</p>
            </div>)}
        </div>
      </div>

      <div className="mt-10 text-center" data-id="element-271">
        <Button variant="secondary" size="lg" data-id="element-272">
          Quiero el plan de 14 días
        </Button>
        <p className="mt-2 text-sm text-[#5a5a5a]" data-id="element-273">
          Funciona aunque tengas semanas caóticas.
        </p>
      </div>
    </Section>;
}